<template>
  <div id="top-header">
    <!-- <dv-decoration-8 class="header-left-decoration" />
    <dv-decoration-5 class="header-center-decoration" />
    <dv-decoration-8 class="header-right-decoration" :reverse="true" /> -->
    <div class="logo"></div>
    <div class="center-title">{{title}}</div>
    <div class="time">
      <div class="refresh">刷新数据:</div>
      <div class="date">{{ currentTime }}</div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/util';
export default {
  name: 'TopHeader',
  props: {
    title: {
      type: String,
      default: '实时销售监控大屏'
    }
  },
  data() {
    return {
      // 初始化时间并添加定时器ID存储
      currentTime: formatTime(new Date()),
      intervalId: null
    }
  },
    // 添加方法和生命周期钩子
  methods: {
    updateTime() {
      this.currentTime = formatTime(new Date());
    }
  },
  mounted() {
    // 立即更新一次并设置每秒更新
    this.updateTime();
    this.intervalId = setInterval(() => this.updateTime(), 1000);
  },
  beforeUnmount() {
    // 组件销毁时清理定时器
    if (this.intervalId) clearInterval(this.intervalId);
  }
}
</script>

<style lang="less" scoped>
#top-header {
  background-image: url('./img/topBg.png');
  background-size: 100% 100%;
  position: relative;
  width: 100%;
  height: 10.83703vh;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  // align-items: center;


  .center-title {
    position: absolute;
    font-size: 2.03703vw;
    font-weight: bold;
    left: 50%;
    top: 1.02037vw;
    transform: translateX(-50%);
  }

  .logo {
    width: 10.649994vw;
    height: 3.031578vh;
    background-image: url('./img/ssz-logo.png');
    background-size: 100% 100%;
    top: 1.62037vw;
    left: 1.21041vw;
    position: absolute;
  }
  .time{
    position: absolute;
    top: 1.42037vw;
    right: 1.21041vw;
    display: flex;
    flex-direction: column;
    text-align: right;
  }
  .refresh{
    font-size: 0.62592vw;
    color: #fff;
  }
 .date{
    font-size: 0.82592vw;
    color: #fff;
    font-weight: bold;
  }
}
</style>
